import { render, staticRenderFns } from "./UCSkeletonShimmer.vue?vue&type=template&id=2a4ebba0&scoped=true&"
import script from "./UCSkeletonShimmer.vue?vue&type=script&lang=ts&"
export * from "./UCSkeletonShimmer.vue?vue&type=script&lang=ts&"
import style0 from "./UCSkeletonShimmer.vue?vue&type=style&index=0&id=2a4ebba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ebba0",
  null
  
)

export default component.exports